import { createQueryNumberToggleHook } from "../useQueryState";

export const useHunterTireSelectedIds = createQueryNumberToggleHook("htId", []);
